
import ShippingFeeConfigComponent from "@/components/system_settings/ShippingFeeConfig.vue"

export default({
  components: {
    ShippingFeeConfigComponent,
  }
})
